// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rt[data-v-5f0c2774]{position:absolute;right:20px;bottom:-20px}", ""]);
// Exports
module.exports = exports;
